import { Collection } from '../collection';
import { CollectionAction } from '../collection-action.interface';
import { CollectionState } from '../collection-state.interface';

const onCreateSuccess = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => ({
  ...state,
  isUpdating: false,
  listOfCollections: [
    ...state.listOfCollections.filter(
      (x) => typeof x.collectionId !== 'undefined',
    ),
    {
      ...action.collection,
      count: (action.collection as Collection).assets.length,
    },
  ] as Collection[],
});

export default onCreateSuccess;
